/**
 * List of azure feature flag ids
 */
export enum AzureFeatureFlagIds {
    testAzureFeatureFlagId = 'testFeatureFlagId', // used only for testing
    hardware_tab = 'hardware_tab',
    ai_suggestions_filter = 'ai_suggestions_filter',
    plenary_rimboard = 'plenary_rimboard',
    compressed_stairs = 'compressed_stairs',
    qrm_comments_attachments_mvp = 'qrm_comments_attachments_mvp',
    ai_deletion_reason = 'ai_deletion_reason',
    wall_sheathing = 'wall_sheathing',
    flag_creation_jira_status_display = 'flag_creation_jira_status_display',
    stairs_rework = 'stairs_rework',
    building_setting_house_wrap_none = 'building_setting_house_wrap_none',
}
